import './TrackLabel.60041e5eea293afc344d96317276d588.css';
export default {"TrackLabel":"_TrackLabel_1z0cg_1","A":"_A_1z0cg_1","B":"_B_1z0cg_1","D":"_D_1z0cg_1","E":"_E_1z0cg_1"};